export default __webpack_public_path__ + "static/media/gournay2.07d0cc68.jpg";